import { CohortTranslation } from './CohortTranslation';
import { useCohortDefinitionDSLSection } from './useCohortDefinitionDSLSection';

export const CohortDefinitionDSLSection = () => {
  const { title, emptyStateMainMessage, emptyStateSubMessage, content } =
    useCohortDefinitionDSLSection();

  return (
    <CohortTranslation
      title={title}
      emptyStateMainMessage={emptyStateMainMessage}
      emptyStateSubMessage={emptyStateSubMessage}
      content={content}
    />
  );
};
